﻿import { useState } from "react";
import {
  Box,
  Card,
  Divider,
  IconButton,
  List,
  ListItem,
  ListItemText,
  Modal,
  Stack,
  Typography
} from "@mui/material";
import { SAVE_RECENTLY_INTERACT_USERS, SEND_EXPENSES } from "../../constant/Apipath";
import { useSelector } from "react-redux";
import { Postrequestcall } from "../../request/Postrequest";
import ShareModule from "../common/ShareModule";
import CloseIcon from "@mui/icons-material/Close";
import SendIcon from "@mui/icons-material/Send";
import moment from "moment";
import { English } from "../../constant/EnglishFallback";
const Sendexpenses = (props) => {
  const { loginData, multiLanguageData } = useSelector((state) => state?.main);
  let currentUserId = loginData?.userInformation?.UserId;
  const [selectedEmails, setSelectedEmails] = useState([]);
  const [loading, setLoading] = useState(false);
  const LanguageData = multiLanguageData?.Expenses || {};
  const {
    TEXT_SEND_EXPENSES = English.Expenses.TEXT_SEND_EXPENSES,
    TEXT_EXPENSES_TO_SEND = English.Expenses.TEXT_EXPENSES_TO_SEND
  } = LanguageData || {};

  const handleSendResumeBuilder = async () => {
    try {
      setLoading(true);
      if (selectedEmails.length !== 0) {
        const expenseArray = props.sendExpenses.map((item) => item.id);
        const emailList = selectedEmails?.map((item) => item.contactEmail);
        const sendExpenseObj = {
          Emails: emailList,
          Expenses: expenseArray,
          UserId: currentUserId
        };

        // Main API call to send expenses
        const sendExpenseResponse = await Postrequestcall(
          SEND_EXPENSES,
          sendExpenseObj,
          loginData?.accessToken
        );

        if (sendExpenseResponse?.data?.message === "OK") {
          const interactionRequests = selectedEmails
            ?.filter((item) => !item.contactId == 0)
            ?.map((item) => ({
              UserId: Number(currentUserId),
              ReturnRecordId: true,
              ReturnRecordError: true,
              SaveList: [
                {
                  Id: 0,
                  UserId: Number(currentUserId),
                  InteractUserId: item.contactId,
                  ModifiedBy: Number(currentUserId),
                  fromScreen: "Resume"
                }
              ]
            }));

          await Promise.all(
            interactionRequests.map((interactionObj) =>
              Postrequestcall(SAVE_RECENTLY_INTERACT_USERS, interactionObj, loginData?.accessToken)
            )
          );
        }
        props?.fetchExpenses(1);
        setLoading(false);
        handleClose();
      }
    } catch (error) {
      setLoading(false);
      console.log("handleSendResumeBuilder(SendExpenses)-> Error Sending Expenses: ", error);
    }
  };

  const handleClose = () => {
    props?.close();
    setSelectedEmails([]);
  };
  return (
    <Modal open={props.isOpen}>
      <Box className="user-modal-responsive">
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "space-between"
          }}>
          <Typography variant="h6">{TEXT_SEND_EXPENSES}</Typography>
          <Stack direction={"row"}>
            <IconButton onClick={handleClose}>
              <CloseIcon />
            </IconButton>
            <IconButton
              loading={loading}
              color="primary"
              onClick={handleSendResumeBuilder}
              disabled={selectedEmails.length === 0}>
              <SendIcon />
            </IconButton>
          </Stack>
        </Box>
        <Box maxHeight={"560px"} overflow={"scroll"} sx={{ scrollbarWidth: "none" }}>
          <Stack spacing={2}>
            <ShareModule
              from="ShareTickets"
              setSelectedEmails={setSelectedEmails}
              selectedEmails={selectedEmails}
            />
            <Stack spacing={1}>
              <Typography variant="body1">{TEXT_EXPENSES_TO_SEND}</Typography>
              <Divider />
            </Stack>
            <Box maxHeight={"300px"} overflow={"scroll"} sx={{ scrollbarWidth: "none" }}>
              <List disablePadding>
                <Stack sx={{ gap: 1 }} >
                  {props.sendExpenses.map((item, index) => (
                    <Card
                      key={index.toString()}
                      className="pagelist-content"
                      sx={{ marginTop: "0px" }}>
                      <ListItem sx={{ m: 0, alignItems: "center" }} key={index.toString()} disablePadding secondaryAction={ <Stack direction={"row"} spacing={1}>
                            <Typography variant="h6" sx={{ color: "primary" }}>
                              $ {item.totalAmount ? item.totalAmount.toFixed(2) : ""}
                            </Typography>
                          </Stack>
                        }>
                        <ListItemText
                          sx={{ pl: 2 }}
                          primary={item.description}
                          secondary={moment(item.expenseDate).format("MMMM DD, YYYY")}
                        />
                      </ListItem>
                    </Card>
                  ))}
                </Stack>
              </List>
            </Box>
          </Stack>
        </Box>
      </Box>
    </Modal>
  );
};

export default Sendexpenses;

